<template>
  <q-page padding class="container">
    <PageHeader
      title="Listagem de Categorias"
      :backRoute="{ name: 'home' }"
      backBehavior="route"
    />
    <div class="row col-12 q-mt-lg text-brand-5 text-weight-bold">
      <div class="col-md-2">
        <div>Unidade</div>
        <ListaUnidadesSelect />
      </div>
    </div>
    <div class="row col-12 justify-between q-mt-lg">
      <q-btn
        label="Adicionar Nova"
        icon="add"
        @click="rightDrawerOpen = !rightDrawerOpen"
        no-caps
        :outline="!rightDrawerOpen"
        color="primary"
      />
      <div
        class="row col-3 justify-end text-brand-5 text-weight-bold q-mb-sm container-input-search"
      >
        <q-input
          rounded
          outlined
          dense
          debounce="300"
          type="text"
          placeholder="Filtrar"
          v-model="filtros.categoria"
        >
          <template v-slot:append>
            <q-icon name="search" />
          </template>
        </q-input>
      </div>
    </div>
    <div
      class="row col-12 q-gutter-md text-brand-5 text-weight-bold q-mt-md container-inputs items-center"
    >
      <div
        style="width: 22%"
        v-for="(elemement, index) in listaCategorias"
        :key="index"
      >
        <q-card
          :class="{
            selecionado: selected === elemement.uuid ? 'selecionado' : '',
          }"
          class="animacao nao-selecionado"
          flat
          @click="
            (selected = elemement.uuid),
              (rightDrawerOpen = true),
              (categoria = elemement),
              (dadosCategoria = elemement)
          "
        >
          <q-card-section
            class="row col-12 justify-center items-center"
            style="height: 160px"
          >
            <span
              :class="{
                ' color-selecionado':
                  selected === elemement.uuid ? 'color-selecionado' : '',
              }"
              style="word-wrap: break-word; width: 100%"
            >
              <span v-if="elemement.nome.length > 21">{{
                elemement.nome.toUpperCase()
              }}</span>
              <span class="row justify-center" v-else>{{
                elemement.nome.toUpperCase()
              }}</span>
            </span>
          </q-card-section>
        </q-card>
      </div>
      <div
        v-if="listaCategorias.length > 11 || pagination2.page > 1"
        class="row col-12 justify-start q-mt-lg q-mr-lg"
      >
        <div>
          <q-pagination
            :disable="disable"
            v-model="pagination2.page"
            color="brand-5"
            active-color="secondary"
            active-text-color="white"
            :max="pagesNumber2"
            :max-pages="5"
            :boundary-numbers="false"
            :direction-links="true"
            size="sm"
          />
        </div>
      </div>
    </div>
    <Transition name="slide-fade">
      <q-card v-if="rightDrawerOpen" class="drawer-modal">
        <div v-if="!tipos" class="q-pa-md text-weight-bold" style="height: 92%">
          <div class="row col-12 justify-between items-center">
            <div class="col-md-12 item-center">
              <q-icon
                style="cursor: pointer"
                name="close"
                class="q-mr-xs q-mb-xs"
                size="19px"
                @click="rightDrawerOpen = false"
              />
              <span style="font-size: 16px" v-if="selected != ''">
                <span>
                  <span v-if="categoria.nome.length > 30">
                    {{ `Categoria: ${categoria.nome.slice(0, 28)}...`
                    }}<q-tooltip>{{ categoria.nome }}</q-tooltip>
                  </span>
                  <span v-else>
                    {{ `Categoria: ${categoria.nome}`
                    }}<q-tooltip>{{ categoria.nome }}</q-tooltip>
                  </span>
                </span>
              </span>
              <span style="font-size: 16px" v-else>
                <span v-if="tab == 'categoria'"> Adicionar Categoria </span>
                <span v-else>Adicionar Tipo</span>
              </span>
            </div>
            <div class="col-12 justify-end">
              <div class="row col-2 justify-end">
                <q-tabs v-model="tab" narrow-indicator dense align="right">
                  <q-tab
                    class="text-black"
                    no-caps
                    name="categoria"
                    label="Categoria"
                  />
                  <q-tab
                    class="text-black"
                    no-caps
                    name="tipo"
                    label="Tipo"
                    :disable="selected == ''"
                  />
                </q-tabs>
              </div>
            </div>
          </div>
          <div
            v-if="tab == 'categoria'"
            class="column justify-between"
            style="height: 100%; width: 100%"
          >
            <div>
              <div style="font-size: 15px" class="q-mt-md">
                <span v-if="selected != ''">
                  <span v-if="tab == 'categoria'">
                    <span v-if="categoria.nome.length > 30">
                      {{ `Editar Categoria: ${categoria.nome.slice(0, 22)}...`
                      }}<q-tooltip>{{ categoria.nome }}</q-tooltip>
                    </span>
                    <span v-else>
                      {{ `Editar Categoria: ${categoria.nome}` }}
                    </span>
                  </span>
                </span>
              </div>
              <div class="col-md-12 q-mt-md">
                <div class="texto-titulo-input q-mb-xs">Nome Categoria</div>
                <q-input
                  v-model="dadosCategoria.nome"
                  dense
                  outlined
                  class="input"
                  placeholder="Nome"
                  :bg-color="
                    selected != '' && !editarCategoria ? 'brand-7' : ''
                  "
                  :disable="selected != '' && !editarCategoria"
                />
              </div>
              <div class="col-md-12 q-mt-md">
                <div class="texto-titulo-input q-mb-xs">
                  Descrição Categoria
                </div>
                <q-input
                  :input-style="{ maxHeight: '200px' }"
                  outlined
                  autogrow
                  v-model="dadosCategoria.descricao"
                  :bg-color="
                    selected != '' && !editarCategoria ? 'brand-7' : ''
                  "
                  :disable="selected != '' && !editarCategoria"
                />
              </div>
              <div class="q-mt-md">
                <q-btn
                  v-if="listaTipos.length > 0"
                  icon="list"
                  color="primary"
                  label="Tipos Associados"
                  dense
                  outline
                  no-caps
                  @click="tipos = true"
                />
                <span v-if="listaTipos.length <= 0 && selected != ''"
                  >Nenhum Tipo Associado a Categoria</span
                >
              </div>
            </div>
            <div class="row q-pb-sm">
              <div v-if="selected != ''">
                <q-btn
                  v-if="!editarCategoria"
                  icon="edit"
                  color="primary"
                  label="Editar Categoria"
                  dense
                  no-caps
                  @click="(editarCategoria = true), receberDadosCategoria()"
                />
                <q-btn
                  v-else
                  icon="check_circle_outline"
                  color="positive"
                  label="Salvar"
                  dense
                  no-caps
                  @click="editarCategoriaDados()"
                />
              </div>
              <div v-else>
                <q-btn
                  icon="check_circle_outline"
                  color="positive"
                  label="Criar Categoria"
                  dense
                  no-caps
                  @click="criarCategoria()"
                />
              </div>
              <div v-if="selected != ''" class="q-ml-sm">
                <q-btn
                  icon="delete"
                  color="negative"
                  label="Excluir Categoria"
                  dense
                  no-caps
                  @click="excluirCategoria(categoria.uuid)"
                />
              </div>
            </div>
          </div>
          <div v-else class="column justify-between" style="height: 100%">
            <div>
              <div style="font-size: 15px" class="q-mt-md">
                <span v-if="selected != ''">
                  <span>
                    <span v-if="categoria.nome.length > 30">
                      {{
                        `Adicionar Tipo na Categoria: ${categoria.nome.slice(
                          0,
                          20
                        )}...`
                      }}<q-tooltip>{{ categoria.nome }}</q-tooltip>
                    </span>
                    <span v-else>
                      {{ `Adicionar Tipo na Categoria: ${categoria.nome}`
                      }}<q-tooltip>{{ categoria.nome }}</q-tooltip>
                    </span>
                  </span>
                </span>
              </div>
              <div class="col-md-12 q-mt-md">
                <div class="texto-titulo-input q-mb-xs">Nome Tipo</div>
                <q-input
                  v-model="tipo.nome"
                  dense
                  outlined
                  class="input"
                  placeholder="Nome"
                />
              </div>
              <div class="col-md-12 q-mt-md">
                <div class="texto-titulo-input q-mb-xs">Validade do Tipo</div>
                <q-input
                  v-model="tipo.validade"
                  dense
                  outlined
                  class="input"
                  placeholder="Em dias"
                />
              </div>
            </div>
            <div>
              <q-btn
                icon="check_circle_outline"
                color="positive"
                label="Criar Tipo"
                dense
                no-caps
                @click="criarTipo()"
              />
            </div>
          </div>
        </div>
        <div v-else class="q-pa-md text-weight-bold" style="height: 92%">
          <div class="row col-12 justify-between items-center">
            <div class="col-md-12 item-center">
              <q-icon
                style="cursor: pointer"
                name="arrow_back_ios"
                class="q-mr-md q-mb-xs text-bold"
                size="19px"
                @click="tipos = false"
              />
              <span style="font-size: 17px" v-if="tabTipo == 'editar'">
                <span v-if="tipo.nome.length > 30">
                  {{ `Tipo: ${tipo.nome.slice(0, 20)}...`
                  }}<q-tooltip>{{ tipo.nome }}</q-tooltip>
                </span>
                <span v-else>
                  {{ `Tipo: ${tipo.nome}` }}
                </span>
              </span>
              <span v-else style="font-size: 17px">Lista Tipos</span>
            </div>
            <div class="row col-12 justify-end">
              <div class="row col-2 justify-end">
                <q-tabs v-model="tabTipo" narrow-indicator dense align="right">
                  <q-tab
                    class="text-black"
                    no-caps
                    name="lista"
                    label="Lista"
                  />
                  <q-tab
                    class="text-black"
                    no-caps
                    name="editar"
                    label="Editar"
                    :disable="selectedTipo == ''"
                  />
                </q-tabs>
              </div>
            </div>
          </div>
          <div
            v-if="tabTipo == 'lista'"
            class="column justify-between"
            style="height: 100%; width: 100%"
          >
            <div>
              <div class="q-mt-md">
                <span
                  class="q-mt-md"
                  style="font-size: 15px"
                  v-if="categoria.nome.length > 30"
                >
                  {{
                    `Tipos Associados na Categoria: ${categoria.nome.slice(
                      0,
                      20
                    )}...`
                  }}<q-tooltip>{{ categoria.nome }}</q-tooltip>
                </span>
                <span class="q-mt-md" style="font-size: 15px" v-else>
                  {{ `Tipos Associados na Categoria: ${categoria.nome}` }}
                </span>
              </div>
              <div class="q-mt-sm">
                <div
                  class="row col-12 justify-end text-brand-5 text-weight-bold q-mb-sm container-input-search"
                >
                  <q-input
                    rounded
                    outlined
                    dense
                    debounce="300"
                    type="text"
                    class="col-12"
                    placeholder="Filtrar"
                    v-model="filtros.tipo"
                  >
                    <template v-slot:append>
                      <q-icon name="search" />
                    </template>
                  </q-input>
                </div>
                <q-table
                  :rows="listaTipos"
                  :loading="loading"
                  dense
                  hide-pagination
                  color="primary"
                  table-header-class="bg-accent text-weight-bold"
                  flat
                  hide-bottom
                  grid
                >
                  <template v-slot:item="props">
                    <div class="col-12 q-mb-xs">
                      <div
                        class="row card text-grid-table text-brand-5 q-pa-sm"
                      >
                        <div
                          class="row col-12 justify-center items-center justify-between"
                        >
                          <div class="col-5">
                            <span class="row col-12 q-mt-sm justify-center"
                              ><strong>Nome</strong>
                              <span class="row col-12 justify-center">
                                <span v-if="props.row.nome?.length > 30"
                                  >{{ `${props.row.nome?.slice(0, 20)}...`
                                  }}<q-tooltip>{{
                                    props.row.nome
                                  }}</q-tooltip></span
                                >
                                <span v-else>{{ props.row.nome }}</span>
                              </span></span
                            >
                          </div>
                          <div class="col-3">
                            <span class="row col-12 q-mt-sm justify-center"
                              ><strong>Validade</strong>
                              <span class="row col-12 justify-center">
                                {{ props.row.validade }}
                              </span></span
                            >
                          </div>
                          <div class="col-4">
                            <div class="row col-12 justify-end q-gutter-x-sm">
                              <q-btn
                                color="black"
                                round
                                size="md"
                                icon="edit"
                                flat
                                @click="
                                  (tipo = props.row),
                                    (dadosTipo = { ...props.row }),
                                    (tabTipo = 'editar'),
                                    (selectedTipo = props.row.nome)
                                "
                              />
                              <q-btn
                                color="red"
                                round
                                size="md"
                                icon="close"
                                flat
                                @click="excluirTipo(props.row.uuid)"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </q-table>
                <div class="row justify-start q-mt-md">
                  <q-pagination
                    :disable="disable"
                    v-model="pagination.page"
                    color="brand-5"
                    active-color="secondary"
                    active-text-color="white"
                    :max="pagesNumber"
                    :max-pages="5"
                    :boundary-numbers="false"
                    :direction-links="true"
                    size="sm"
                  />
                </div>
              </div>
            </div>
          </div>
          <div v-else class="column justify-between" style="height: 100%">
            <div>
              <div style="font-size: 15px" class="q-mt-md">
                <span v-if="tipo.nome.length > 30">
                  {{ `Editar Tipo: ${tipo.nome.slice(0, 20)}...`
                  }}<q-tooltip>{{ tipo.nome }}</q-tooltip>
                </span>
                <span v-else>
                  {{ `Tipo: ${tipo.nome}` }}
                </span>
              </div>
              <div class="col-md-12 q-mt-md">
                <div class="texto-titulo-input q-mb-xs">Nome Tipo</div>
                <q-input
                  v-model="dadosTipo.nome"
                  dense
                  outlined
                  class="input"
                  placeholder="Categoria"
                  :bg-color="selectedTipo != '' && !tipoEditar ? 'brand-7' : ''"
                  :disable="selectedTipo != '' && !tipoEditar"
                />
              </div>
              <div class="col-md-12 q-mt-md">
                <div class="texto-titulo-input q-mb-xs">Validade do Tipo</div>
                <q-input
                  v-model="dadosTipo.validade"
                  dense
                  outlined
                  class="input"
                  placeholder="Em dias"
                  :bg-color="selectedTipo != '' && !tipoEditar ? 'brand-7' : ''"
                  :disable="selectedTipo != '' && !tipoEditar"
                />
              </div>
            </div>
            <div class="q-pb-sm">
              <div v-if="selectedTipo != ''">
                <q-btn
                  v-if="!tipoEditar"
                  icon="edit"
                  color="primary"
                  label="Editar Tipo"
                  dense
                  no-caps
                  @click="tipoEditar = true"
                />
                <q-btn
                  v-else
                  icon="check_circle_outline"
                  color="positive"
                  label="Salvar"
                  dense
                  no-caps
                  @click="editarTipo()"
                />
              </div>
            </div>
          </div>
        </div>
      </q-card>
    </Transition>
    <div
      v-if="rightDrawerOpen"
      @click="rightDrawerOpen = false"
      class="mascara"
    ></div>
  </q-page>
</template>

<script>
import { onMounted, ref, watch, computed } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";

import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import PageHeader from "../../../components/PageHeader.vue";

export default {
  components: { ListaUnidadesSelect, PageHeader },
  setup() {
    const store = useStore();
    const quasar = useQuasar();

    const rightDrawerOpen = ref(false);
    const tab = ref("categoria");
    const tabTipo = ref("lista");
    const categoria = ref({ nome: "", descricao: "", uuid: "" });
    const tipo = ref({ nome: "", validade: "" });
    const listaCategorias = ref([]);
    const selected = ref("");
    const selectedTipo = ref("");
    let tipos = ref(false);
    const listaTipos = ref([]);
    let loading = ref(false);
    let disable = ref(false);
    let editarCategoria = ref(false);
    let tipoEditar = ref(false);
    const dadosCategoria = ref({ nome: "", descricao: "", uuid: "" });
    const filtros = ref({ filtroTipo: "" });
    const dadosTipo = ref("");
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 6,
    });
    const pagination2 = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 6,
    });

    const criarCategoria = async () => {
      try {
        await store.dispatch("documento/criarCategoria", {
          nome: dadosCategoria.value.nome,
          descricao: dadosCategoria.value.descricao,
          unidadeId: store.state.org.unidadeData.id,
        });
        listarCategorias();
        dadosCategoria.value = {
          nome: "",
          descricao: "",
          uuid: "",
        };
        quasar.notify({
          message: "Categoria criada com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        rightDrawerOpen.value = false;
      } catch (error) {
        quasar.notify({
          message: "Erro ao criar categoria.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const criarTipo = async () => {
      try {
        await store.dispatch("documento/criarTipo", {
          nome: tipo.value.nome,
          validade: parseInt(tipo.value.validade),
          categoriaUuid: categoria.value.uuid,
        });
        listarTipos();
        tipo.value = {
          nome: "",
          validade: "",
        };
        quasar.notify({
          message: "Tipo Criado com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        quasar.notify({
          message: "Erro ao criar tipo.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const listarCategorias = async (page = 0, rowsNumber = 12) => {
      await store.state.org.unidadeData.id;
      try {
        disable.value = true;
        const response = await store.dispatch("documento/listarCategorias", {
          unidadeId: store.state.org.unidadeData.id,
          page: page,
          perPage: rowsNumber,
          nome: filtros.value.categoria,
        });
        listaCategorias.value = response.data.resultado.dados;
        pagination2.value.rowsPerPage = response.data.resultado.perPage;
        pagination2.value.page = response.data.resultado.currentPage;
        pagination2.value.rowsNumber = response.data.resultado.total;
        disable.value = false;
      } catch (error) {
        console.log(error);
      }
    };

    const listarTipos = async (page = 0, rowsNumber = 6) => {
      await store.state.org.unidadeData.id;
      try {
        loading.value = true;
        disable.value = true;
        const response = await store.dispatch("documento/listarTipos", {
          unidadeId: store.state.org.unidadeData.id,
          categoriaUuid: categoria.value.uuid,
          page: page,
          nome: filtros.value.tipo,
          perPage: rowsNumber,
        });
        listaTipos.value = response.data.resultado.dados;
        pagination.value.rowsPerPage = response.data.resultado.perPage;
        pagination.value.page = response.data.resultado.currentPage;
        pagination.value.rowsNumber = response.data.resultado.total;
        loading.value = false;
        disable.value = false;
      } catch (error) {
        console.log(error);
      }
    };

    const excluirTipo = async (uuid) => {
      try {
        await store.dispatch("documento/excluirTipo", {
          uuid: uuid,
        });
        listarTipos();
        quasar.notify({
          message: "Tipo excluido com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        quasar.notify({
          message: "Erro ao excluir tipo.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const excluirCategoria = async (uuid) => {
      try {
        await store.dispatch("documento/excluirCategoria", {
          uuid: uuid,
        });
        listarCategorias();
        rightDrawerOpen.value = false;
        quasar.notify({
          message: "Categoria excluida com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        quasar.notify({
          message: "Erro ao excluir categoria.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const receberDadosCategoria = () => {
      dadosCategoria.value = { ...categoria.value };
    };

    const editarCategoriaDados = async () => {
      if (
        dadosCategoria.value.nome == categoria.value.nome &&
        dadosCategoria.value.descricao == categoria.value.descricao
      ) {
        editarCategoria.value = false;
        return;
      }
      try {
        await store.dispatch("documento/editarCategoria", {
          descricao: dadosCategoria.value.descricao,
          nome: dadosCategoria.value.nome,
          unidadeId: store.state.org.unidadeData.id,
          uuid: dadosCategoria.value.uuid,
        });
        editarCategoria.value = false;
        listarCategorias();
        categoria.value = { ...dadosCategoria.value };
        quasar.notify({
          message: "Categoria editada com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        quasar.notify({
          message: "Erro ao editar categoria.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const editarTipo = async () => {
      if (
        dadosTipo.value.nome == tipo.value.nome &&
        dadosTipo.value.validade == tipo.value.validade
      ) {
        tipoEditar.value = false;
        return;
      }
      try {
        await store.dispatch("documento/editarTipo", {
          validade: dadosTipo.value.validade,
          nome: dadosTipo.value.nome,
          uuid: dadosTipo.value.uuid,
          categoriaUuid: categoria.value.uuid,
        });
        tipoEditar.value = false;
        listarTipos();
        tipo.value = { ...dadosTipo.value };
        quasar.notify({
          message: "Tipo editado com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        quasar.notify({
          message: "Erro ao editar tipo.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    watch(
      () => rightDrawerOpen.value,
      () => {
        if (!rightDrawerOpen.value) {
          selected.value = "";
          selectedTipo.value = "";
          editarCategoria.value = false;
          categoria.value = {
            nome: "",
            descricao: "",
          };
          tipos.value = false;
          listaTipos.value = [];
          tipo.value = {
            nome: "",
            validade: "",
          };
          dadosCategoria.value = {};
          tipoEditar.value = false;
          dadosTipo.value = {};
        }
        if (rightDrawerOpen.value == true && selected.value != "") {
          tab.value = "categoria";
          return;
        }
        tab.value = "categoria";
      }
    );

    watch(
      () => selected.value,
      () => {
        if (selected.value != "") {
          listarTipos();
        }
      }
    );

    watch(
      () => pagination.value.page,
      () => {
        listarTipos(pagination.value.page, pagination.value.rowsPerPage);
      }
    );

    watch(
      () => filtros.value.tipo,
      () => {
        listarTipos();
      }
    );

    watch(
      () => filtros.value.categoria,
      () => {
        listarCategorias();
      }
    );

    watch(
      () => pagination2.value.page,
      () => {
        listarCategorias(pagination2.value.page, pagination2.value.rowsPerPage);
      }
    );

    watch(
      () => tabTipo.value,
      () => {
        if (tabTipo.value == "lista") {
          selectedTipo.value = "";
          dadosTipo.value = {};
          tipo.value = {};
        }
      }
    );

    watch(
      () => tab.value,
      () => {
        editarCategoria.value = false;
      }
    );

    watch(
      () => store.state.org.unidadeData.id,
      () => {
        rightDrawerOpen.value = false;
        listarCategorias();
      }
    );

    watch(
      () => tipos.value,
      () => {
        editarCategoria.value = false;
        tipoEditar.value = false;
        selectedTipo.value = "";
        tabTipo.value = "lista";
        tipo.value = {
          nome: "",
          validade: "",
        };
      }
    );

    onMounted(() => {
      listarCategorias();
    });

    return {
      rightDrawerOpen,
      tab,
      criarCategoria,
      categoria,
      listarCategorias,
      listaCategorias,
      selected,
      tipos,
      criarTipo,
      tipo,
      listarTipos,
      tabTipo,
      selectedTipo,
      listaTipos,
      excluirTipo,
      loading,
      editarCategoria,
      dadosCategoria,
      receberDadosCategoria,
      editarCategoriaDados,
      tipoEditar,
      dadosTipo,
      editarTipo,
      pagination,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      pagination2,
      pagesNumber2: computed(() =>
        Math.ceil(pagination2.value.rowsNumber / pagination2.value.rowsPerPage)
      ),
      disable,
      excluirCategoria,
      filtros,
    };
  },
};
</script>

<style scoped>
.container {
  height: 100%;
}
.animacao {
  transition: all 0.5s;
  cursor: pointer;
}
.animacao:hover {
  -webkit-transform: scale(1.1);
  -ms-transform: scale(1.1);
  transform: scale(1.1);
}
.drawer-modal {
  border: 2px solid black;
  position: absolute;
  right: 0;
  width: 450px;
  top: 106px;
  height: calc(100% - 10px);
  position: fixed;
  max-height: 650px;
  border-radius: 10px 1px 1px 10px;
  margin: 2px;
  z-index: 3;
}
.slide-fade-enter-active {
  transition: all 0.5s ease-out;
}
.selecionado {
  transform: scale(1.1);
  border: 1px solid blue !important;
}
.color-selecionado {
  color: blue;
}
.nao-selecionado {
  border: 1px solid #707070;
}
.slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(400px);
}
.titulo-modal {
  font-size: 15px;
}
.mascara {
  background-color: black;
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
  opacity: 0.4;
}
.card {
  border: 1px solid #707070;
  border-radius: 5px;
}
@media (max-width: 1200px) {
  .drawer-modal {
    max-height: 85%;
  }
}
@media (max-width: 900px) {
  .drawer-modal {
    max-height: 80%;
    top: 118px;
  }
}
@media (max-width: 600px) {
  .drawer-modal {
    max-height: 80%;
    top: 107px;
  }
}
</style>
